import { createTheme, ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { breakpoints } from "../config/cssbreakpoints";

const theme = createTheme({
	breakpoints: {
		values: {
			xs: breakpoints.xs,
			sm: breakpoints.sm,
			md: breakpoints.md,
			lg: breakpoints.lg,
			xl: breakpoints.xl,
		},
	},
});

export const ThemeProvider = ({ children }) => {
	return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};
